import Vue from "vue";

Vue.mixin({
  methods: {
    alertFailError() {
      this.$alert(
        "Oops! something went wrong. Please contact admin or try again later",
        {
          closeOnClickModal: true,
          confirmButtonText: "OK",
          type: "error",
        }
      );
    },
    alertCatchError(e) {
      if (e == "Error: Request failed with status code 401") {
        this.$alert(`กรุณาเข้าสู่ระบบใหม่อีกครั้ง`, {
          closeOnClickModal: true,
          confirmButtonText: "OK",
          type: "error",
          callback: action => {
            this.$store.commit("SIGNOUT");
            this.$router.push({ path: "/" }).catch(() => {
              window.location.reload();
            });
          }
        });

      } else {
        this.$alert(`${e}`, {
          closeOnClickModal: true,
          confirmButtonText: "OK",
          type: "error",
        });
      }
    },
  },
});
